import { ExternalLink } from "lucide-react";
import Link from "next/link";

import { Button } from "~/components/ui/button";
import { type FragmentOf, type SiteLocale, readFragment } from "~/lib/graphql";

import * as fragment from "./graphql";

export function CtaButton(props: {
  record: FragmentOf<typeof fragment.CtaButtonFragment>;
  locale: SiteLocale;
}) {
  const record = readFragment(fragment.CtaButtonFragment, props.record);

  const getButtonUrl = () => {
    if (record.externalUrl) {
      return record.externalUrl;
    }
    if (record.internalUrl) {
      return record.internalUrl;
    }
    return "#";
  };

  const isExternal = !!record.externalUrl;
  const url = getButtonUrl();
  const label = record.label || "Learn More";

  return (
    <div className="my-6 flex justify-center">
      {isExternal ? (
        <Button size="lg">
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2"
          >
            {label}
            <ExternalLink className="h-4 w-4" />
          </a>
        </Button>
      ) : (
        <Button asChild size="lg">
          <Link href={url}>{label}</Link>
        </Button>
      )}
    </div>
  );
}
